<template>

    <div class="crud-scroller" ref="crudscroller">
        <slot></slot>
    </div>

</template>

<style lang="scss">
    div.crud-scroller {
        position:relative;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        height: calc(100vh - 245px);
        max-height: calc(100vh - 245px);

        h2{
            margin: 5px 0 5px;
            font-size: 1.15em;
            color: #659dba;
            clear:both;
        }
        ul{
            margin-bottom:30px;
            a{
                color:$brand;
                text-decoration:none;
            }
            li{
                @include clearfix();
            }
        }

        @include mobile(){
            height:auto;
            max-height:auto;
        }

        .grouped-item-listings {
            position: relative;
            h2 {
                position: relative;
                z-index: 1;
                background-color: #ecf0f1;
                padding: 0.5em;
                border-radius: 0.3em;
                color: #333;
                &.fixed {
                    position: fixed;
                    @include mobile() {
                        top: 122px;
                    }
                    @include desktop() {
                        top: 125px;
                    }
                    box-sizing: border-box;
                    z-index: 0;
                    background-color: #fff;
                    width: 200px;
                    padding-top: 0;
                    padding-bottom: 0;
                    &.absolute {
                        position: absolute;
                    }
                }
            }
        }

        li.items-list-item {
            margin: 0;
            border-bottom: 1px dashed #dedede;
            padding-top: 2px;
            padding-bottom: 2px;
            padding-left:0.5em;
            padding-right:0.5em;
            a {
                padding-top: 0.3em;
                padding-bottom: 0.3em;
                display: block;
                border-radius: 2px;
            }
            &.active a, a:hover {
                background-color: $yellow;
            }
            &:last-of-type {
                border-bottom: 0;
                padding-top: 0;
                padding-bottom: 0;
                a {
                    padding-top: 0;
                    padding-bottom: 0;
                }
            }
        }

        .hide-me-please{
            visibility:hidden;
        }
    }
</style>

<script>
        export default {
        data() {
            return {}
        },
        watch: {},
        computed: {
            name(){
                return this.$parent.name;
            }
        },
        methods: {

        },
        mounted() {}
    }
</script>
